import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { useParams } from "react-router-dom";
import { getLiveDetails } from '../../actions/live.js';

import useStyles from './styles.js'

import { AppBar, Box, Button, ButtonGroup, CircularProgress, Container, FormControl, getRadioUtilityClass, Grid, InputLabel, MenuItem, Modal, Paper, Select, Stack, Tab, Tabs, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';

import LiveExport from './LiveExport.js';

import io from 'socket.io-client';
import { resolveMessage } from '../../actions/socket.js';


import 'react-image-crop/dist/ReactCrop.css'
import LiveMultiplex from './multiplex/LiveMultiplex.js';
import TabPanel from '../../dsasComponents/TabPanel.js';
import a11yProps from '../../dsasComponents/a11yProps.js';
import ActuInLive from './inlive/ActuInLive.js';
import MatchInLive from './inlive/MatchInLive.js';
import { getLiveCompetitions, getLiveDates } from '../../api/index.js';
import { useFetch } from '../../api/useFetch.js';
import CalendarNavigation from './navigation/CalendarNavigation.js';
import DayNavigation from './navigation/DayNavigation.js';
import LiveMultiplexScore from './multiplex/LiveMultiplexScore.js';
import { fi } from 'date-fns/locale';
import { useNotifications } from '../../v2/notifications/NotificationManager.js';


const LiveMatch = ({mode}) => {

    const {id : idLive} = useParams();

    const [value, setValue] = React.useState(undefined);
    const [date, setDate] = useState()

    const { addNotification } = useNotifications();
    

    const dispatch = useDispatch()

    

    const live = useSelector((state) => state.live)

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const socketInfo = useSelector((state) => state.socket)
    const [isConnected, setIsConnected] = useState(false);

    const URLgetLiveDates = useCallback(() => {
      if(mode === 'calendar'){
        return getLiveDates(idLive)
      }else if(mode === 'day'){
        return getLiveCompetitions(idLive)
      }

      return getLiveDates(idLive)
  }, [idLive])

  const [liveDates] = useFetch(URLgetLiveDates)

  const [competitionSelected, setCompetitionSelected] = useState({})

  const getAutomaticDateValue = () => {
    if(!liveDates || !liveDates.length)
        return ''

    const currentDate = new Date();
    const today = currentDate.toISOString().split('T')[0];
    
    const sortedDates = liveDates.sort();
    
    // Recherche de la date d'aujourd'hui
    if (liveDates.includes(today)) {
        return today;
    }
    
    // Recherche de la date supérieure la plus proche
    for (let i = 0; i < sortedDates.length; i++) {
        if (sortedDates[i] > today) {
        return sortedDates[i];
        }
    }
    
    // Aucune date supérieure, retourne la date inférieure la plus proche (dernière date du tableau)
    return sortedDates[sortedDates.length - 1];
}

const getAutomaticCompetitionSelected = () => {
  if(!liveDates || !liveDates.length)
      return ''

  let resolvedCompetition = liveDates[0]

  setCompetitionSelected(resolvedCompetition)
}

useEffect(() => {
  if(competitionSelected && competitionSelected._id){
    let resolvedDay = competitionSelected.activeDay

    setDate(resolvedDay)
  }

}, [competitionSelected])

useEffect(() => {

  if(date){

    if(value >=0){
      setValue(0)
    }

    dispatch(getLiveDetails(idLive, date, mode, competitionSelected._id))
  }
    
}, [,date])

    useEffect(() => {
      if(!liveDates || !liveDates.length)
            return
        // SOCKET 
        const URL = 'http://localhost:5000'

        const url = process.env.NODE_ENV === 'development' ? URL : process.env.REACT_APP_COLLECTOR_API_URL
        const socket = io.connect(url, {
          path : process.env.NODE_ENV === 'development' ? /collector-api/ + /socket.io/ : process.env.REACT_APP_BASE_URL + /socket.io/,
          reconnect: true, 
          query: {
            "idLive": idLive
          },
          withCredentials: true,
          transports: ["websocket", "polling"]
    });

      socket.on('connect', () => {
        setIsConnected(true);

        if(!date){
          if(mode === "day"){
            getAutomaticCompetitionSelected()
          }else{
            setDate(getAutomaticDateValue())
          }
        }    
        else
            dispatch(getLiveDetails(idLive, date, mode, competitionSelected._id))
      });

      socket.on('disconnect', () => {
        setIsConnected(false);
      });

      // PERMET DE RECEVOIR TOUT LE LIVE ?
      socket.on('updated_match', (match) => {
          // Mettre à jour le live
          dispatch(resolveMessage(match, addNotification))
      })

      /*socket.on('SERVER_TIME', ({collectorServerTime}) => {
          // Mettre à jour le live
          // On remet le collectorServertime à l'heure
          dispatch({ type : EDIT_COLLECTOR_TIMESTAMP, payload : {collectorServerTime}})

          //dispatch({ type: EDIT_MATCH_IN_LIVE, payload: match})
      })*/

      return () => {
        socket.disconnect() 
      };
    }, [liveDates, idLive])

    const handleOpenLive = () => {
      let urlLocation = undefined
      //On récupère l'url de live
      if(process.env.NODE_ENV === 'development'){
        urlLocation = 'http://localhost:3006';
      }else{
        urlLocation = process.env.REACT_APP_LIVE_CLIENT_URL;
      }

      const url = live.actualites.length > 0 ? urlLocation + "/actualite/"+idLive : urlLocation + "/"+idLive 

      window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
    }

    /*if(!teams || !competitions || !players)
      return 'loading'*/

    const handleSelectMatch = (e) => {
      setValue(parseInt(e.target.value))
    }

    const enableMultiplexScore = useMemo(() => {
      // Si au moins 1 match possède 2 équipe en niveau 4 de subscription
      const result = live.matchsDetails && live.matchsDetails.find(m => m.homeTeam.subscription >= 4 && m.awayTeam.subscription >= 4)
  
      return result
  
    }, [live.matchsDetails])

    useEffect(() => {
      if(!live.matchsDetails && !live.actualitesDetails)
          return

      if(value===undefined){
        if(enableMultiplexScore)
          setValue(-2)
        else
          setValue(0)
      }
  }, [live])

  const buildCompetitionOrder = (orderedStructure) => {
    const sortedCompetitions = Object.entries(orderedStructure)
      .flatMap(([discipline, competitions]) =>
        Object.entries(competitions).map(([competitionId, days]) => ({
          competitionId,
          competitionName: days[Object.keys(days)[0]][0].competition.name,
        }))
      )
      .sort((a, b) => a.competitionName.localeCompare(b.competitionName));
  
    return sortedCompetitions.map((competition) => competition.competitionId);
  };

  const orderedStructure = useMemo(() => {
    const { competitionOrder, matchsDetails } = live;

    if (!matchsDetails) {
      return;
    }
  
    // Créer une structure pour stocker les matchs ordonnés
    const structure = {};

    let tab = 0
  
    // Parcourir les matchs et les ranger dans la structure
    matchsDetails.forEach((match) => {
      const { discipline, competition, day, dateTime } = match;
  
      // Vérifier si la discipline existe déjà dans la structure
      if (!structure[discipline]) {
        structure[discipline] = {};
      }
  
      // Vérifier si la compétition existe déjà dans la discipline
      if (!structure[discipline][competition._id]) {
        structure[discipline][competition._id] = {};
      }
  
      // Vérifier si le jour existe déjà dans la compétition
      if (!structure[discipline][competition._id][day]) {
        structure[discipline][competition._id][day] = [];
      }
  
      // Ajouter le match au jour correspondant de la compétition
      structure[discipline][competition._id][day].push({...match, tab : tab++});
    });
  
    const finalCompetitionOrder = (competitionOrder && competitionOrder.length) ? competitionOrder : buildCompetitionOrder(structure);
  
    // Ordonner les compétitions selon l'ordre spécifié dans competitionOrder
    const orderedStructure = {};
  
    finalCompetitionOrder.forEach((competitionId) => {
      Object.entries(structure).forEach(([discipline, competitions]) => {
        if (competitions[competitionId]) {
          if (!orderedStructure[discipline]) {
            orderedStructure[discipline] = {};
          }
  
          // Copier les jours de la compétition
          orderedStructure[discipline][competitionId] = { ...competitions[competitionId] };
        }
      });
    });
  
    return orderedStructure;
  }, [live.matchsDetails, live.competitionOrder])

    if(live && live._id)
    return  (<Box sx={{position : 'relative', maxWidth : '1200px', margin : 'auto', marginTop : 2, borderTop : 'thick double rgba(0, 0, 100, .1)', paddingTop : 1, textAlign : 'center'}}>

                <Grid container>
                  <Grid item xs={10}>
                    <Button onClick={handleOpenLive} sx={[{position : 'absolute', left : '50%', transform : 'translateX(-50%)', background:'#3160a3', color : 'white', zIndex : 1000}, (theme) => ({
                      '&:hover': {
                        background:'#6d7581', color : 'white'
                      },
                    }),]}> OUVRIR LE DIRECT</Button>
                  </Grid>
                  <Grid item xs={2}>
                    <LiveExport idLive={idLive} isActu={live.actualites.length > 0} live={live}/>
                  </Grid>

                </Grid>

              {mode==='calendar' && <CalendarNavigation liveDates={liveDates} activeDate={date} setActiveDate={setDate} />}
              {mode==='day' && <Box>
              <Select
                value={competitionSelected._id}
                onChange={(event) => setCompetitionSelected(liveDates.find(c => c._id === event.target.value))}
                displayEmpty
                fullWidth
                sx={{ minWidth: 200 }}
                >
                <MenuItem value="" disabled>
                    Sélectionner une compétition
                </MenuItem>
                {liveDates.map((competition) => (
                    <MenuItem key={competition._id} value={competition._id}>
                      {competition.name}
                    </MenuItem>
                ))}
              </Select>
                  <DayNavigation liveDates={competitionSelected.days} activeDate={date} setActiveDate={setDate} />
                </Box>
              }
              {live.matchsDetails && <>
              
                {live.matchsDetails.length > 0 && <FormControl sx={{ m: 1, minWidth: 120}}>
                  <InputLabel htmlFor="grouped-match-select">Matchs</InputLabel>
                  <Select native defaultValue="" id="grouped-match-select" label="Matchs" onChange={handleSelectMatch} value={value}>
                    <option key={-1} value={-1}>Tous les matchs</option>
                    {enableMultiplexScore && <option key={-2} value={-2}>Tous les matchs score</option>}
                    {orderedStructure &&
                      Object.entries(orderedStructure).map(([discipline, competitions]) => (
                          discipline &&
                            Object.entries(competitions).map(([competitionId, matches]) => (
                              
                                Object.entries(matches).map(([day, dayMatches]) => 
                                  <optgroup label={matches[Object.keys(matches)[0]][0].competition.name + ' - J'+ day} key={matches[Object.keys(matches)[0]][0].competition.name + ' - J'+ day} style={{textTransform : 'uppercase'}}>
                                  {dayMatches
                                    .sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime))
                                    .map((match) => (
                                      <option style={{textTransform : 'uppercase'}}
                                        key={match.idMatch}
                                        value={match.tab}
                                        selected={match.tab === value}
                                      >
                                        {"J" + match.day + ": " + match.homeTeam.name + "-" + match.awayTeam.name}
                                      </option>
                                    ))}
                                    </optgroup> 
                                )
                                
                            ))
                      ))}
                  </Select>
                </FormControl>}

                    {orderedStructure &&
                      Object.entries(orderedStructure).map(([discipline, competitions]) => (
                          discipline &&
                            Object.entries(competitions).map(([competitionId, matches]) => (
                              <>
                                {Object.entries(matches).map(([day, dayMatches]) =>
                                  dayMatches
                                    .sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime))
                                    .map((match) => (
                                      <TabPanel value={value} index={match.tab} key={match.idMatch}> <MatchInLive match={match} key={match._id} competitionName={match.competition.name}/> </TabPanel>
                                    ))
                                )}
                              </>
                            ))
                      ))}
              </>}

              {value === -1 && <LiveMultiplex matchs={orderedStructure}/>}
              {value === -2 && <LiveMultiplexScore matchs={orderedStructure}/>}
              {live.actualitesDetails && <>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable" scrollButtons="auto">
                  {live.actualitesDetails.map((actu, idx) => <Tab label={actu.name} {...a11yProps(idx)} />)}
                </Tabs>

                {live.actualitesDetails.map((actu, idx) => <TabPanel value={value} index={idx}> <ActuInLive actu={actu} liveId={live._id}/> </TabPanel>)}
              
              </>}
                

            
            

        
        </Box>)

    return <CircularProgress/>
}

export default LiveMatch